module.exports = __webpack_public_path__ + "img/5.d0572e82.png";